import React from "react";
import { useTranslation } from "react-i18next";
import Recommend1 from "../../images/Recommend/Table.webp";
import Recommend2 from "../../images/Recommend/treeeee.webp";
import commissionImage from "../../images/ReferCode/commission.webp";
import { COMMON_ALT } from "../../constant";

const Recommend = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`recommend.${key}`);
  return (
    <section className="w-full mt-[10px] rounded-[5] px-[10px] py-[16px] bg-base-light-white dark:bg-base-light-dark relative mb-[15px] flex flex-col items-center gap-[15px] font-medium">
      <h1 className="text-center my-2 !mt-2 text-base-light-dark dark:text-base-light-white text-xl md:text-3xl font-semibold">
        {i18n("Recommend to friends")}
      </h1>
      <img src={commissionImage} alt={COMMON_ALT} />
      <div className="text-base-deep-dark w-full dark:text-base-light-white">
        <div className="p-8 font-normal">
          <div className="mb-6 flex flex-col">
            {i18n(
              "There is no threshold to become a 911 entertainment agent, no investment cost, everyone can become an agent!"
            )}
          </div>
          <div className="mb-6 flex flex-col">
            {i18n(
              "Just register on the official website and log in to the game, and share your exclusive QR code. When you become a member of the 911 official website through the exclusive QR code you share, you can check the membership (agent) in [Agent Join] and My Commission For related information, at this time, the system will automatically upgrade you to become an agent of 911 Entertainment. Whether you play the game yourself or someone becomes your agent one after another, you will get your own betting commission + unlimited-level agent performance commission every week. The total amount of commissions for each performance allows you to easily earn a pot of gold without knowing it."
            )}
          </div>
          <div className="mb-6 flex flex-col">
            {i18n(
              "Take you only recommended 3 members as an example, these 3 (directly affiliated) members also only recommended 3 (agent) members, continue to promote the branch, but after a while, you will find that your total performance reaches more than 1 million."
            )}
          </div>
          <div className="mb-6 flex flex-col">
            {i18n(
              "The commission is settled once a day and consists of 2 items:"
            )}
          </div>
          <div className="mb-6 flex flex-col">
            {i18n(
              "Own betting commission + unlimited level agent performance commission = daily commission"
            )}
          </div>
          <div className="mb-6 flex flex-col">
            {i18n("Commission level table")}
            <br></br>
            <image src={Recommend1} alt="" className="w-full" />
          </div>
          <div className="mb-6 flex flex-col">
            {i18n(
              "The total bets of each layer of each agent line are added up according to the total bets of their offline members, which is the total performance limit of this agent line."
            )}
          </div>
          <div className="mb-6 flex flex-col">{i18n("Assumption")}</div>
          <div className="mb-6 flex flex-col">
            {i18n(
              "The top-level agent has accumulated 10.3 billion total bets"
            )}
          </div>
          <div className="mb-6 flex flex-col">
            {i18n("Bet 1.1 billion on itself")}
          </div>
          <div className="mb-6 flex flex-col">
            {i18n("The commission is 10.3 billion*0.65%=66950000")}
          </div>
          <div className="mb-6 flex flex-col">
            {i18n("The calculation method of the lower agent commission:")}
          </div>
          <div className="mb-6 flex flex-col">
            {i18n("1. Distribute according to the commission level table")}
          </div>
          <div className="mb-6 flex flex-col">
            {i18n(
              "2. Assuming that there are 2 directly affiliated members under the top-level agent (one with a total performance of 8 billion and one with 1.2 billion),"
            )}
          </div>
          <div className="mb-6 flex flex-col">
            {i18n("Dividable commission")}
          </div>
          <div className="mb-6 flex flex-col">
            {i18n("8 billion*0.6%=48000000")}
          </div>
          <div className="mb-6 flex flex-col">
            {i18n("1.2 billion*0.5%=6000000")}
          </div>
          <div className="mb-6 flex flex-col">
            {i18n(
              "The commission available to the top-level agent is 669.5000-48000000-6000000=12,950,000"
            )}
          </div>
          <div className="mb-6 flex flex-col">
            <image src={Recommend2} alt="" className="w-full" />
          </div>
          <div className="mb-6 flex flex-col">
            {i18n("Instructions for issuing agent commissions")}
          </div>
          <div className="mb-6 flex flex-col">
            {i18n(
              "1.Each agent line does not limit the agent level and the number of agents, all belong to your downline."
            )}
          </div>
          <div className="mb-6 flex flex-col">
            {i18n(
              "2.Accumulated performance of members (effective code washing amount), regardless of whether it is your direct member or a member recommended by your direct member, is cumulative performance. The total performance quota of the top-level agent on the line is the cumulative amount of all agents at the lower level. For performance, to obtain high agent commissions, it is necessary to break through the comparison commission level table and achieve the required agent commission %. The weekly commission sum can be viewed from the total performance comparison commission system table for the corresponding level."
            )}
          </div>
          <div className="mb-6 flex flex-col">
            {i18n("Vui lòng liên hệ CSKH để rút tiền hoa hồng")}
          </div>
          　
        </div>
      </div>
    </section>
  );
};

export default Recommend;
